import {CIRCLES_API} from "../../config";
import * as ActionCreators from "./creators";
import { pushNotification } from "../ui_notifications/creators";
import fetchRetry from '../fetch_retry';

export function fetchCommitment(circleId) {
  return function(dispatch, getState) {     
    dispatch(ActionCreators.fetchingCommitment());
    let url = `${CIRCLES_API}/commitment/${circleId}`;
    let request_options = {
      headers: { "Content-Type": "application/json"}
    }
    if(getState().iam.accessToken){
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        response => response.json(),
        error => {
          dispatch(ActionCreators.errorFetchingCommitment(error));
        }
      )
      .then(response => {     
          if('message' in response && response.message === "Internal Server Error"){
            dispatch(pushNotification("errors.commitment.fetch", "error"));            
            dispatch(ActionCreators.errorFetchingCommitment(response.message));
          }else{
            dispatch(ActionCreators.fetchedCommitment(response, circleId));
          }        
      });
  };
}

export function signAgreement(circleId) {
  return function(dispatch, getState) {     
    dispatch(ActionCreators.signingCommitment());
    let url = `${CIRCLES_API}/commitment`;

    let request_options = {
      headers: { "Content-Type": "application/json"},
      method: "POST",
      body: JSON.stringify({circle_guid: circleId})
    }

    if(getState().iam.accessToken){
      request_options.headers["Authorization"] = `Bearer ${getState().iam.accessToken}`;
    }

    return fetchRetry(url, request_options, dispatch, getState)
      .then(
        response => response.json(),
        error => {
          dispatch(ActionCreators.errorFetchingCommitment(error));
        }
      )
      .then(response => {     
          if('message' in response && response.message === "Internal Server Error"){
            dispatch(pushNotification("errors.commitment.sign", "error"));            
            dispatch(ActionCreators.errorFetchingCommitment(response.message));
          }else{
            dispatch(pushNotification("success.commitment.sign", "success"));
            dispatch(ActionCreators.signedCommitment(response, circleId));
          }        
      });
  };
}